var TaskModel = BaseObjectModel.extend({
  init: function (data) {
    this._super(data);
  },
  className: "TaskModel",

  start() {
    let model;
    let accessRights;
    if (WA.getLocation() !== 'task') {
      model = {
        TaskID: this.ID,
        Subject: this.Subject,
        ActiveText: '',
        Observers: this.Observers,
        Performers: this.Performers,
        JobKind: _getJobKind(),
        Deadline: this.Deadline || '',
        InitiatorId: this.InitiatorID,
        RouteType: '',
        Rights: '',
        IsEncyptEnabled: ''
      };
      accessRights = ACCESS_RIGHTS.EMPTY;
    }
    this.fireAll(
      'Start',
      () => startTask(model, accessRights),
      WA.CR.StandardRouteCode,
    );
  },

  loadEvents: function (standardRouteEvents) {
    var me = this;
    var eventsForCurrentRoute = standardRouteEvents[ this.StandardRouteCode ]

    if (typeof eventsForCurrentRoute !== 'undefined' && typeof eventsForCurrentRoute.task !== 'undefined') {
      // грузим только события задачи.
      $.each(eventsForCurrentRoute.task, function (eventName, eventCallback) {
        me.bind(eventName, eventCallback);
      });
    }
  },

  // standardRouteCode указываем, если вызываем событие "До запроса параметров".
  fireAll: function (eventName, mainFunc, standardRouteCode) {
    function fire(eventName) {
      if (typeof WebAccess.Events[ standardRouteCode ] != 'undefined' && typeof WebAccess.Events[ standardRouteCode ].task != 'undefined') {
        var r = WebAccess.Events[ standardRouteCode ].task[ eventName ].call(this, arguments[ 1 ]);
        if (typeof r != 'undefined' && !r) {
          return false;
        }
        return true;
      }
    }

    if (typeof standardRouteCode != 'undefined') {
      var isRun = false;
      var me = this;

      // Обертка над callback с вызвовом Before и After событий.
      var mainFuncWrapper = function (result) {
        if (typeof result == 'undefined' || result) {
          mainFunc();
          me.fire('After' + eventName);
        }
        isRun = true;
      };

      var r = fire('Before' + eventName, mainFuncWrapper);
      if (!isRun) {
        mainFuncWrapper(r);
      }
    }
    else {
      // если не означен standardRouteId, то берем родительский fireAll (находимся в задаче и там все разруливается).
      this._super(eventName, mainFunc);
    }
  }
});